import { PageInfo, PageParams } from 'graphql/types.generated'
import { LembreteModel } from 'view/atendimentos/detail/soap/aside/types/LembreteModel'

type LembretePageInfo = Pick<PageInfo, 'totalPages' | 'totalElements'>

interface LembretePaginateResult {
  lembretes: LembreteModel[]
  pageInfo: LembretePageInfo
}

export function paginateLembretes(lembretes: LembreteModel[], pageParams: PageParams): LembretePaginateResult {
  const lembretesResult = applyPageNosLembretes(lembretes, pageParams.page, pageParams.size)

  const newPageInfo = createPageInfo(lembretes.length, pageParams.size)

  return { lembretes: lembretesResult, pageInfo: newPageInfo }
}

export function applyPageNosLembretes(
  lembretesDatabaseComTodosDaCache: LembreteModel[],
  pageNumber: number,
  pageSize: number = 0
): LembreteModel[] {
  const offset = pageNumber * pageSize
  return lembretesDatabaseComTodosDaCache.slice(offset, offset + pageSize)
}

export function createPageInfo(totalLembretes: number, pageSize: number): LembretePageInfo {
  return {
    totalElements: totalLembretes,
    totalPages: Math.ceil(totalLembretes / pageSize),
  }
}
